import React, { useMemo, useEffect, useState, useCallback } from 'react';
import { useGeolocation } from '../hooks/useGeolocation';
import { useFilters } from '../hooks/useFilters';

import VenueList from './VenueList';
import ContractDialog from './ContractDialog';
import NotesDialog from './NotesDialog';
import { req } from '../utils';
import { ReminderDialog } from './ReminderDialog';

const filterAndSortVenues = (venues, filterType, searchTerm, isLeads = false) => {
  if (isLeads) {
    if (!venues?.results) return [];
    let filteredVenues = venues.results;

    if (filterType !== 'all') {
      filteredVenues = filteredVenues.filter(venue => 
        venue.types && venue.types.includes(filterType)
      );
    }

    if (searchTerm) {
      filteredVenues = filteredVenues.filter(venue =>
        venue?.name?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    return filteredVenues;
  } else {
    // Handle BottleCycler venues
    if (!Array.isArray(venues)) return [];
    
    let filteredVenues = venues;
    
    if (searchTerm) {
      filteredVenues = filteredVenues.filter(venue =>
        venue?.venue_name?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    return filteredVenues;
  }
};

const CustomerList = ({ selectedItem, onItemClick, isLeads = false,venues }) => {

  const { location } = useGeolocation();
  const { filterType, searchTerm, handleFilterChange, handleSearch } = useFilters();

  const [lastFetchLocation, setLastFetchLocation] = useState(null);
  const [lastFetchTime, setLastFetchTime] = useState(null);
  const [reminderDialogOpen, setReminderDialogOpen] = useState(false);
  const [selectedBusiness, setSelectedBusiness] = useState(null);

  // Helper function to calculate distance between two points using Haversine formula
  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    if (!lat1 || !lon1 || !lat2 || !lon2) return 0;
    
    const R = 6371; // Earth's radius in kilometers
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
      Math.sin(dLon/2) * Math.sin(dLon/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c; // Distance in kilometers
  };

  const shouldRefetchVenues = useCallback((newLocation) => {
    if (!lastFetchTime || !lastFetchLocation) return true;
    
    // Check if 5 minutes have passed
    const fiveMinutes = 5 * 60 * 1000;
    const timeDiff = Date.now() - lastFetchTime;
    
    // If location has changed significantly (more than 1km)
    const locationChanged = newLocation && lastFetchLocation && calculateDistance(
      newLocation.lat,
      newLocation.lng,
      lastFetchLocation.lat,
      lastFetchLocation.lng
    ) > 1;

    return timeDiff > fiveMinutes || locationChanged;
  }, [lastFetchTime, lastFetchLocation]);


  const filteredVenues = useMemo(() => {
    return filterAndSortVenues(venues, filterType, searchTerm, isLeads);
  }, [venues, filterType, searchTerm, isLeads]);

  const handleReminderClick = (business) => {
    setSelectedBusiness(business);
    setReminderDialogOpen(true);
  };

  const handleReminderSubmit = async (reminderData) => {
    try {
      await req('POST', 'save_reminder', {
        date: reminderData.reminderDate,
        note: reminderData.note,
        business_id: selectedBusiness.id,
        // Add any other necessary data
      });
      // Optional: Show success message
    } catch (error) {
      console.error('Error saving reminder:', error);
      // Optional: Show error message
    }
  };

  return (
    <div>
     
      
      <VenueList 
        venues={venues}
        loading={false}
        location={location}
        selectedItem={selectedItem}
        onItemClick={onItemClick}
        isLeads={isLeads}

      />
      
      <ContractDialog />
      <NotesDialog />
      <ReminderDialog
        open={reminderDialogOpen}
        onClose={() => setReminderDialogOpen(false)}
        businessName={selectedBusiness?.name || ''}
        onSubmit={handleReminderSubmit}
      />
    </div>
  );
};

export default CustomerList;
